import Modal, { IModal } from '../Modals/ModalV2/BaseModal'

interface DetailModalProps extends Omit<IModal, 'children' | 'isOpen'> {
  children: React.ReactNode
}

export const DetailModal = ({ children, ...rest }: DetailModalProps) => {
  return (
    <Modal isOpen={true} {...rest}>
      {() => children}
    </Modal>
  )
}
